module.exports = __webpack_public_path__ + "img/download.b49ade43.svg";